import "./helpers/nav";
import { addAnimation } from "./helpers/scroll";
import "./utils/form";
import { UserInput } from "./components/project-input";
import { inject } from "@vercel/analytics";

inject();
new UserInput();
addAnimation();
